import React from "react";
import './SalesHeader.css';

const SalesHeader = () => {
    return (
        <div className="header2 d-flex justify-content-center justify-content-md-start align-items-center sticky-top shadow-sm p-3">
            <div className="headerLogo">
                <img src="/MELWA-LOGO-W.png" alt="Melwa Logo" width="130" height="27" className="img-fluid" />
            </div>
        </div>
    );
};

export default SalesHeader;
